/**
 * Tesoreria API Service
 * Cuentas Bancarias, Pagos, Movimientos, CxC/CxP
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const tesoreriaService = {
  // ============================================
  // Cuentas Bancarias
  // ============================================
  cuentasBancarias: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/cuentas-bancarias/`, { params: filters }),
    getById: (id) => api.get(`${API_BASE_URL}/cuentas-bancarias/${id}/`),
    create: (data) => api.post(`${API_BASE_URL}/cuentas-bancarias/`, data),
    update: (id, data) => api.patch(`${API_BASE_URL}/cuentas-bancarias/${id}/`, data),
    delete: (id) => api.delete(`${API_BASE_URL}/cuentas-bancarias/${id}/`),
    getMovimientos: (id, filters = {}) => api.get(`${API_BASE_URL}/cuentas-bancarias/${id}/movimientos/`, { params: filters }),
    getSaldoAFecha: (id, fecha) => api.get(`${API_BASE_URL}/cuentas-bancarias/${id}/saldo-a-fecha/`, { params: { fecha } }),
  },

  // ============================================
  // Pagos
  // ============================================
  pagos: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/pagos/`, { params: filters }),
    getById: (id) => api.get(`${API_BASE_URL}/pagos/${id}/`),
    create: (data) => api.post(`${API_BASE_URL}/pagos/`, data),
    update: (id, data) => api.patch(`${API_BASE_URL}/pagos/${id}/`, data),
    delete: (id) => api.delete(`${API_BASE_URL}/pagos/${id}/`),
    aprobar: (id) => api.post(`${API_BASE_URL}/pagos/${id}/aprobar/`),
    ejecutar: (id) => api.post(`${API_BASE_URL}/pagos/${id}/ejecutar/`),
    anular: (id) => api.post(`${API_BASE_URL}/pagos/${id}/anular/`),
  },

  // ============================================
  // Cuentas por Cobrar
  // ============================================
  cuentasPorCobrar: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-cobrar/`, { params: filters }),
    getAging: (filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-cobrar/aging/`, { params: filters }),
    getEstadoCuenta: (clienteId, filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-cobrar/cliente/${clienteId}/`, { params: filters }),
  },

  // ============================================
  // Cuentas por Pagar
  // ============================================
  cuentasPorPagar: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-pagar/`, { params: filters }),
    getCronograma: (filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-pagar/cronograma/`, { params: filters }),
    getEstadoCuenta: (proveedorId, filters = {}) => api.get(`${API_BASE_URL}/cuentas-por-pagar/proveedor/${proveedorId}/`, { params: filters }),
  },
};

export default tesoreriaService;
